import { createSelector } from '@reduxjs/toolkit';
import { selectStrategy } from '../../store/selectors';

export const selectStrategyDashboardState = createSelector(selectStrategy, (modelState) => modelState.strategyDashboard);
export const selectParameters = createSelector(selectStrategyDashboardState, (dashboard) => dashboard.parameters);
export const selectStrategyDashboard = createSelector(selectStrategyDashboardState, (DashboardState) => DashboardState.strategyDashboard);
export const selectStrategyDetails = createSelector(selectStrategyDashboardState, (DashboardState) => DashboardState.strategyDetails);
export const selectMonthlyDashboardChart = createSelector(selectStrategyDashboardState, (DashboardState) => DashboardState.monthlyDashboardChart);
